import { render } from "./BenefitListComponent.vue?vue&type=template&id=878d2bde"
import script from "./BenefitListComponent.vue?vue&type=script&lang=js"
export * from "./BenefitListComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/settings/Benefit/BenefitListComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "878d2bde"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('878d2bde', __exports__)) {
    api.reload('878d2bde', __exports__)
  }
  
  module.hot.accept("./BenefitListComponent.vue?vue&type=template&id=878d2bde", () => {
    api.rerender('878d2bde', render)
  })

}


export default __exports__